import { render, staticRenderFns } from "./FrzChamberViewGraphics.vue?vue&type=template&id=5de89a8e"
import script from "./FrzChamberViewGraphics.vue?vue&type=script&lang=js"
export * from "./FrzChamberViewGraphics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports